import React from 'react';
import Section from './section';
import { Col, Row } from 'antd';
import LineChart from './lineChart';
import styles from '../index.module.scss';

interface iAlarmAnalysisProps {
    hmwData?: any[];
    ldwData?: any[];
    fcwData?: any[];
    aebData?: any[];
    analysisData?: AlarmTrendAnalysis;
}

interface AlarmTrendAnalysis {
    overall_trend_analysis?: string;
    aeb_trend_analysis?: string;
    fcw_trend_analysis?: string;
    ldw_trend_analysis?: string;
    hmw_trend_analysis?: string;
}

// 报警分析模块
const AlarmAnalysis = (props: iAlarmAnalysisProps) => {
    const { hmwData = [], ldwData = [], fcwData = [], aebData = [], analysisData } = props;

    // 转换图表数据格式
    const convertAlarmChartData = (actualData: any[], name: string) => {
        if (!actualData || !Array.isArray(actualData) || actualData.length === 0) return [];

        const actualSeries = {
            name: `${name}实际值`,
            value: actualData.map(item => {
                const value = item.actual || 0;
                const formattedValue = Number.isInteger(value) ? value : Number(value.toFixed(2));
                return [item.date, formattedValue] as [string, number];
            })
        };

        const standardSeries = {
            name: `${name}标准值`,
            value: actualData.map(item => {
                const value = item.standard || 0;
                const formattedValue = Number.isInteger(value) ? value : Number(value.toFixed(2));
                return [item.date, formattedValue] as [string, number];
            })
        };

        return [actualSeries, standardSeries];
    };

    // 转换各类报警数据
    const hmwChartData = convertAlarmChartData(hmwData, 'HMW预警');
    const ldwChartData = convertAlarmChartData(ldwData, 'LDW预警');
    const fcwChartData = convertAlarmChartData(fcwData, 'FCW预警');
    const aebChartData = convertAlarmChartData(aebData, 'AEB制动');

    const chartItems = [
        {
            key: 'hmw',
            data: hmwChartData,
            title: 'HMW预警趋势分析',
            yAxisLabel: '预警次数',
            analysis: analysisData?.hmw_trend_analysis,
        },
        {
            key: 'ldw',
            data: ldwChartData,
            title: 'LDW预警趋势分析',
            yAxisLabel: '预警次数',
            analysis: analysisData?.ldw_trend_analysis,
        },
        {
            key: 'fcw',
            data: fcwChartData,
            title: 'FCW预警趋势分析',
            yAxisLabel: '预警次数',
            analysis: analysisData?.fcw_trend_analysis,
        },
        {
            key: 'aeb',
            data: aebChartData,
            title: 'AEB制动趋势分析',
            yAxisLabel: '制动次数',
            analysis: analysisData?.aeb_trend_analysis,
        },
    ];

    // 如果没有图表数据和分析结果，显示默认提示
    const hasData = hmwChartData.length > 0 || ldwChartData.length > 0 || fcwChartData.length > 0 || aebChartData.length > 0;
    const hasAnalysis = Boolean(
        analysisData?.overall_trend_analysis
        || analysisData?.aeb_trend_analysis
        || analysisData?.fcw_trend_analysis
        || analysisData?.ldw_trend_analysis
        || analysisData?.hmw_trend_analysis
    );

    if (!hasData && !hasAnalysis) {
        return (
            <Section title="七、报警分析">
                <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                    暂无报警分析数据
                </div>
            </Section>
        );
    }

    return (
        <Section title="七、报警分析">
            {analysisData?.overall_trend_analysis && (
                <div className={styles.analysisBlock} style={{ marginTop: 0, marginBottom: 16 }}>
                    <h4>分析结果</h4>
                    <div className={styles.analysisContent}>
                        {analysisData.overall_trend_analysis}
                    </div>
                </div>
            )}
            <Row gutter={[16, 16]}>
                {chartItems
                    .filter(item => item.data.length > 0 || item.analysis)
                    .map(item => (
                        <Col span={12} key={item.key}>
                            {item.data.length > 0 && (
                                <LineChart
                                    data={item.data}
                                    title={item.title}
                                    yAxisLabel={item.yAxisLabel}
                                    xAxisLabel="日期"
                                />
                            )}
                            {item.analysis && (
                                <div className={styles.analysisBlock}>
                                    <h4>分析结果</h4>
                                    <div className={styles.analysisContent}>
                                        {item.analysis}
                                    </div>
                                </div>
                            )}
                        </Col>
                    ))}
            </Row>
        </Section>
    );
};

export default AlarmAnalysis;
